import { URLS } from "@/constants/constants";
import type { BrandOptions } from "@/app/(auth)/select-brand/components/BrandAction/type";
import { create } from "zustand";

interface UnsavedChangesProps {
  isFormDirty: boolean;
  isModalOpen: boolean;
  pendingRoutes: string | null;
  refinementInProgress: boolean;
  isCancelWithoutSavingClicked: boolean;
  linkText: string;
  projectId: string;
  projectType: string;
  focusId: string | null;
  brandToBeSelected: BrandOptions | null;

  openModal: (open: boolean) => void;
  closeModal: () => void;
  setFormDirty: (dirty: boolean) => void;
  setPendingRoutes: (route: string | null) => void;
  setRefinementInProgress: (inProgress: boolean) => void;
  setIsCancelWithoutSavingClicked: (clicked: boolean) => void;
  setLinkText: (text: string) => void;
  setProjectId: (projectId: string) => void;
  setProjectType: (projectType: string) => void;
  setFocusId: (id: string | null) => void;
  openBrandSwitchModal: (brand: BrandOptions) => void;
}

export const useUnsavedChangesStore = create<UnsavedChangesProps>((set) => ({
  isFormDirty: false,
  isModalOpen: false,
  pendingRoutes: URLS.HOME,
  refinementInProgress: false,
  isCancelWithoutSavingClicked: false,
  linkText: "",
  projectType: "",
  projectId: "",
  focusId: null,
  brandToBeSelected: null,

  openModal: (open) => set({ isModalOpen: open }),
  closeModal: () => set({ isModalOpen: false, brandToBeSelected: null }),
  setFormDirty: (dirty) => set({ isFormDirty: dirty }),
  setPendingRoutes: (route) => set({ pendingRoutes: route }),
  setRefinementInProgress: (inProgress) => set({ refinementInProgress: inProgress }),
  setIsCancelWithoutSavingClicked: (clicked) => set({ isCancelWithoutSavingClicked: clicked }),
  setLinkText: (text) => set({ linkText: text }),
  setProjectId: (projectId) => set({ projectId }),
  setProjectType: (projectType) => set({ projectType }),
  setFocusId: (id) => set({ focusId: id }),
  openBrandSwitchModal: (brand) => set({ isModalOpen: true, pendingRoutes: URLS.HOME, brandToBeSelected: brand }),
}));
